module.exports = __webpack_public_path__ + "static/img/lysj.5c266ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/lysj.jpg
// module id = Q9Ku
// module chunks = 0